module.exports = __webpack_public_path__ + "static/todo-da1a138b4f55d0ed6b2d983199b3e04b.png";